/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OverviewInputs */

const en_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const de_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überblick`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {OverviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const overview = /** @type {((inputs?: OverviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OverviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overview(inputs)
	return de_overview(inputs)
});